import { render, staticRenderFns } from "./index.vue?vue&type=template&id=68ad866c"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/lib/jenkins/workspace/prod2/jobs/build/partner-assets-build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('68ad866c')) {
      api.createRecord('68ad866c', component.options)
    } else {
      api.reload('68ad866c', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=68ad866c", function () {
      api.rerender('68ad866c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/vab/components/VabLink/index.vue"
export default component.exports